import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { WidgetComponent } from './widget.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import _ from 'lodash';
import { Subscription } from 'rxjs/internal/Subscription';
import { Unsubscriber } from '../common/helpers/unsubscriber';

@Component({
    selector: 'adm4-selection-property',
    template: `
    <div [formGroup]='group'>
      <mat-form-field class='full-width'>
        <mat-select #selection
          [disableOptionCentering]='true'
          [multiple]='multiple'
          [formControlName]='widgetProperty.propertyKey'
          [required]='parameters.required'
          [adm4ControlDisable]='readOnly'
          (blur)='onValidate($event)'
          (focus)='onSelect($event, selection)'>
          @for (option of parameters.options; track option) {
            <mat-option
              [value]='option'>{{option}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="selection-default">{{ defaultText }}</div> <!-- displayed below -->
      @if (!valid) {
        <span>{{validationMessage}}</span>
      }
    </div>
    `,
    styleUrls: ['widget.component.scss', 'selection-property.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectionPropertyComponent),
            multi: true
        }],
    standalone: false
})
export class SelectionPropertyComponent extends WidgetComponent implements OnInit, OnDestroy {
  valid = true;
  validationMessage: string;
  multiple: boolean = false;

  private valueChangesSubscription: Subscription;

  override ngOnInit(): void {
    super.ngOnInit();
    this.multiple = this.maxAllowed > 1;
    this.valueChangesSubscription = this.group.controls[this.widgetProperty.propertyKey].valueChanges
        .subscribe(value => {
          this.onSelectionChange(value);
        });
  }

  onSelectionChange(value: any) {
    this.valid = !Array.isArray(value) || this.checkMinValidity(value) && this.checkMaxValidity(value);
  }

  checkMinValidity(value: any) {
    if (this.minRequired > (Array.isArray(value) ? value.length : (value ? 1 : 0))) {
      this.validationMessage = `You must select at least ${this.minRequired} options`;
      return false;
    }
    return true;
  }

  checkMaxValidity(value: any) {
    if (this.maxAllowed < (Array.isArray(value) ? value.length : 1)) {
      this.validationMessage = `You can select at most ${this.maxAllowed} options`;
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    Unsubscriber.unsubscribeFrom(this.valueChangesSubscription);
  }
}
